import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as apiMisc from '../api/requests/misc.api';
import * as apiApplicant from '../api/requests/applicant.api';
import { setApplicationStatus, setOverallSubmissionStatus } from '../redux/General/general.actions';
import { CandidateStatusEnum } from '../types/interfaces/applicant.interface';

const useApplicationSubmission = (workerUuid: string) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handlePostOverallSubmission = useCallback(async () => {
        try {
            await apiMisc.setApplicationStatus('application-submitted');
            dispatch(setApplicationStatus('application-submitted'));
            dispatch(setOverallSubmissionStatus('pending'));

            await apiApplicant.updateCandidateStatus({ workerUuid, candidateStatus: CandidateStatusEnum.IN_REVIEW });
            navigate('/check/application-submitted', { replace: true });

        } catch (error: any) {
            console.error('Error during submission:', error);
            throw error;
        }
    }, [dispatch, navigate, workerUuid]);

    return { handlePostOverallSubmission };
};

export default useApplicationSubmission;